function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;
  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e2) {
          throw _e2;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e3) {
      didErr = true;
      err = _e3;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
export var I18nManager = /*#__PURE__*/function () {
  function I18nManager(details) {
    var initialTranslations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, I18nManager);
    this.details = details;
    this.translationGetters = new Map();
    this.fallbacks = new Map();
    this.translations = new Map();
    this.asyncTranslationIds = new Set();
    this.subscriptions = new Map();
    this.translationPromises = new Map();
    this.idsToUpdate = new Set();
    this.enqueuedUpdate = void 0;
    for (var _i = 0, _Object$entries = Object.entries(initialTranslations); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        _id = _Object$entries$_i[0],
        translation = _Object$entries$_i[1];
      this.translations.set(_id, translation);
      this.asyncTranslationIds.add(_id);
    }
  }
  _createClass(I18nManager, [{
    key: "loading",
    get: function get() {
      return this.translationPromises.size > 0;
    }
  }, {
    key: "resolve",
    value: function () {
      var _resolve = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Promise.all(_toConsumableArray(this.translationPromises.values()));
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function resolve() {
        return _resolve.apply(this, arguments);
      }
      return resolve;
    }()
  }, {
    key: "extract",
    value: function extract() {
      var _this = this;
      return _toConsumableArray(this.asyncTranslationIds).reduce(function (extracted, id) {
        return _objectSpread(_objectSpread({}, extracted), {}, _defineProperty({}, id, _this.translations.get(id)));
      }, {});
    }
  }, {
    key: "register",
    value: function register(_ref) {
      var id = _ref.id,
        translations = _ref.translations,
        fallback = _ref.fallback;
      if (!this.fallbacks.has(id)) {
        this.fallbacks.set(id, fallback);
      }
      if (this.details.fallbackLocale != null && fallback != null) {
        var translationId = getTranslationId(id, this.details.fallbackLocale);
        if (!this.translations.has(translationId)) {
          this.translations.set(translationId, fallback);
        }
      }
      if (this.translationGetters.has(id)) {
        return;
      }
      var translationGetter = translations ? normalizeTranslationGetter(translations) : noop;
      this.setTranslations(id, translationGetter);
    }
  }, {
    key: "state",
    value: function state(ids) {
      var _this2 = this;
      var _this$details = this.details,
        locale = _this$details.locale,
        fallbackLocale = _this$details.fallbackLocale;
      var possibleLocales = getPossibleLocales(locale);
      var omitFallbacks = fallbackLocale != null && possibleLocales.includes(fallbackLocale);
      var loading = false;
      var hasUnresolvedTranslations = false;
      var translations = ids.reduce(function (otherTranslations, id) {
        var translationsForId = [];
        var _iterator = _createForOfIteratorHelper(possibleLocales),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _locale = _step.value;
            var translationId = getTranslationId(id, _locale);
            var translation = _this2.translations.get(translationId);
            if (translation == null) {
              if (_this2.translationPromises.has(translationId)) {
                hasUnresolvedTranslations = true;
              }
            } else {
              translationsForId.push(translation);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (translationsForId.length === 0 && hasUnresolvedTranslations) {
          loading = true;
        }
        if (!omitFallbacks) {
          var fallback = _this2.fallbacks.get(id);
          if (fallback != null) {
            translationsForId.push(fallback);
          }
        }
        return [].concat(_toConsumableArray(otherTranslations), translationsForId);
      }, []);
      return {
        loading: loading,
        translations: translations
      };
    }
  }, {
    key: "subscribe",
    value: function subscribe(ids, subscriber) {
      var _this3 = this;
      this.subscriptions.set(subscriber, ids);
      return function () {
        _this3.subscriptions["delete"](subscriber);
      };
    }
  }, {
    key: "update",
    value: function update(details) {
      this.details = details;
      var _iterator2 = _createForOfIteratorHelper(this.translationGetters),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
            _id2 = _step2$value[0],
            translationGetter = _step2$value[1];
          this.setTranslations(_id2, translationGetter);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var _iterator3 = _createForOfIteratorHelper(this.subscriptions),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
            subscriber = _step3$value[0],
            ids = _step3$value[1];
          subscriber(this.state(ids), this.details);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "setTranslations",
    value: function setTranslations(id, translationGetter) {
      var _this4 = this;
      this.translationGetters.set(id, translationGetter);
      var _iterator4 = _createForOfIteratorHelper(getPossibleLocales(this.details.locale)),
        _step4;
      try {
        var _loop = function _loop() {
          var locale = _step4.value;
          var translationId = getTranslationId(id, locale);
          if (_this4.translations.has(translationId)) {
            return "continue";
          }
          var translations = translationGetter(locale);
          if (isPromise(translations)) {
            var promise = translations.then(function (result) {
              _this4.translationPromises["delete"](translationId);
              _this4.translations.set(translationId, result);
              _this4.asyncTranslationIds.add(translationId);
              if (result != null) {
                _this4.updateSubscribersForId(id);
              }
            })["catch"](function () {
              _this4.translationPromises["delete"](translationId);
              _this4.translations.set(translationId, undefined);
              _this4.asyncTranslationIds.add(translationId);
            });
            _this4.translationPromises.set(translationId, promise);
          } else {
            _this4.translations.set(translationId, translations);
          }
        };
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _ret = _loop();
          if (_ret === "continue") continue;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "updateSubscribersForId",
    value: function updateSubscribersForId(id) {
      var _this5 = this;
      this.idsToUpdate.add(id);
      if (this.enqueuedUpdate != null) {
        return;
      }
      var isBrowser = typeof window !== 'undefined';
      var enqueue = isBrowser ? window.requestAnimationFrame : setImmediate;
      this.enqueuedUpdate = enqueue(function () {
        delete _this5.enqueuedUpdate;
        var idsToUpdate = _toConsumableArray(_this5.idsToUpdate);
        _this5.idsToUpdate.clear();
        var _iterator5 = _createForOfIteratorHelper(_this5.subscriptions),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _step5$value = _slicedToArray(_step5.value, 2),
              subscriber = _step5$value[0],
              ids = _step5$value[1];
            if (ids.some(function (id) {
              return idsToUpdate.includes(id);
            })) {
              subscriber(_this5.state(ids), _this5.details);
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      });
    }
  }]);
  return I18nManager;
}();
function getPossibleLocales(locale) {
  var split = locale.split('-');
  return split.length > 1 ? ["".concat(split[0], "-").concat(split[1].toUpperCase()), split[0]] : [locale];
}
function isPromise(maybePromise) {
  return maybePromise != null && maybePromise.then != null;
}
function getTranslationId(id, locale) {
  return "".concat(id, "__").concat(locale);
}
function noop() {
  return undefined;
}
function normalizeTranslationGetter(translations) {
  return typeof translations === 'function' ? translations : function (locale) {
    return translations[locale];
  };
}